import businessType from './business-type'
import businessCategory from './business-category'
import partner from './partner'
import information from './information'
import verification from './verification'
import organization from './organization'
import activeUsers from './active-users'
import dropOff from './drop-off'

export default [
  // ...partner, ...businessCategory, ...businessType,
  ...information, ...verification, ...organization, ...activeUsers, ...dropOff,
]
